import { motion } from "framer-motion";

export function ParallaxBanner({ src, alt }) {
  return (
    <div className="relative h-[280px] md:h-[350px] overflow-hidden">
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        className="absolute inset-0 w-full h-[130%] object-cover -top-[15%]"
        initial={{ scale: 1.05 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: false, margin: "-100px" }}
        transition={{ duration: 1.2, ease: "easeOut" }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#004333]/20 via-transparent to-[#1a1008]/20" />
    </div>
  );
}
